import dClient from "../../Components/api/reduxLoaderApi";
import failStatus from "../../Components/utils/failStatus";
import {notification} from "../../Components/functions/notification/notificationFunction";
import React from "react";
import {initNoticeForm} from "./slice";


export const createNotice = (data, callback = false) => async (
    dispatch,
    getState,
) => {
    const res = await dClient(
        'post',
        `admin/popup`,
        data,
        {},
        1,
        true,
    );
    if (failStatus(res, dispatch)) return '';
    dispatch(notification("success", "", <h3>با موفقیت ایجاد شد</h3>, false))
    return callback && callback();
};

export const getNoticeById = ({id}, callback = false) => async (
    dispatch,
    getState,
) => {
    const res = await dClient(
        'get',
        `admin/popup/${id}`,
        {},
        {},
        1,
        true,
    );
    if (failStatus(res, dispatch)) return '';
    dispatch(initNoticeForm(res.data.data))
    return callback && callback();
};

export const editNotice = (id, data, callback = false) => async (
    dispatch,
    getState,
) => {
    const res = await dClient(
        'post',
        `admin/popup/${id}`,
        data,
        {},
        1,
        true,
    );
    if (failStatus(res, dispatch)) return '';
    dispatch(notification("success", "", <h3>با موفقیت ویرایش شد</h3>, false))
    return callback && callback();
};

export const deleteNotice = ({ notice_id }, callback = false) => async (
    dispatch,
    getState,
) => {
    const res = await dClient(
        'delete',
        `admin/popup/${notice_id}`,
        {},
        {},
        1,
        true,
    );
    if (failStatus(res,dispatch)) return '';
    return callback && callback(res);
};